import { Grid2 as Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import ListViewTableHeaderCell from './ListViewTableHeaderCell';
import ListViewTableHeaderCheckbox from './ListViewTableHeaderCheckbox';

const styles = () => ({
    headerRow: {
        flexWrap: 'nowrap',
        marginBottom: '20px',
        width: '100%',
        minWidth: '100%',
    },
});

function ListViewHeaderRow({
    classes,
    selectStatus,
    onSelectAll,
    selectColumnProps,
    sx,
    columns,
    onSortChange,
    sortBy,
    sortDirection,
    sortIconPosition = 'right',
    /**
     * @param {boolean} shouldCleanSort
     * if true, the behavior when clicking on a column header will be:
     * 1rst click: set sortByColumn & sort direction to asc.
     * 2nd click: set sortByColumn to null & sort direction to desc.
     * 3rd click: set sortByColumn to null & sort direction to asc. (cleanup sorting)
     */
    shouldCleanSort = false,
}) {
    /**
     * Handles sorting of the table
     */
    function handleSort(key) {
        if (shouldCleanSort) {
            if (sortBy !== key) {
                onSortChange(key, 'asc');
            } else if (sortDirection === 'asc') {
                onSortChange(key, 'desc');
            } else {
                onSortChange(null, 'asc');
            }
        } else {
            const newDirection = sortBy === key && sortDirection === 'asc' ? 'desc' : 'asc';
            onSortChange(key, newDirection);
        }
    }

    return (
        <Grid container className={classes.headerRow} sx={sx}>
            {selectStatus !== undefined && onSelectAll && (
                <ListViewTableHeaderCheckbox
                    status={selectStatus}
                    onClick={onSelectAll}
                    {...selectColumnProps}
                />
            )}
            {columns.map((column) => (
                <ListViewTableHeaderCell
                    name={column.label}
                    title={column.title}
                    size={column.size}
                    sortKey={column?.sortable === false ? '' : column.key}
                    sorted={sortBy === column.key}
                    key={column.key}
                    onSort={() => handleSort(column.key)}
                    sortDirection={sortDirection}
                    sx={column.sx}
                    sortIconPosition={sortIconPosition}
                />
            ))}
        </Grid>
    );
}

export default withStyles(styles)(ListViewHeaderRow);
